
// @ts-ignore
import {translate} from '@elements/translations';
import {ref, watch, reactive, onMounted, defineComponent} from 'vue';
import {useTicketStore} from '../../stores/TicketStore';
import {useActivityStore} from '../../stores/ActivityStore';
import {storeToRefs} from 'pinia'
import LoadingSpinner from "../../components/loading/LoadingSpinner.vue";
import { throwAlertMessage, addParamsToUrl, fetcher } from "../../utils/utils";
import { getCrossSellingDataUrl } from '../../utils/config-helper';
import TicketTeaser from "../../components/ticket/teaser.vue";

export default defineComponent({
    name: 'SuccessView',
    components: {
        TicketTeaser,
        LoadingSpinner,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        ticketId: {
            type: String,
            required: true,
        },
        stepViews: {
            type: Array,
            required: true
        },
        successData: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        },
        isUsedInActivity: {
            type: Boolean,
            default: false
        },
        activityId: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const ticketStore = useTicketStore();
        const {
            step,
            selectedDateStart,
            selectedDateEnd,
            selectedOption, // -> productId
            ticketConfigurations,
            selectedCurrency
        } = storeToRefs(ticketStore);

        const activityStore = useActivityStore();
        const {
            selectedDateStart: activitySelectedDateStart,
            selectedDateEnd: activitySelectedDateEnd,
            ticketConfigurations: activityTicketConfigurations,
            selectedCurrency: activitySelectedCurrency
        } = storeToRefs(activityStore);

        const _config = window._config || {};
        const baseUrl = _config.successUrls;

        if (!baseUrl) {
            throwAlertMessage('warning', 'MISSING CONFIG', 'Missing config "_config.successUrls". Value of "_config.successUrls" was not set in _config', true);
        }

        const continueUrl = baseUrl.continueShopping;
        const cartUrl = baseUrl.cart;
        const checkoutUrl = baseUrl.checkout;

        function clickCheckoutButton () {
            window.dataLayer.push({
                'event': 'click_checkout',
                'type': 'ticket_configurator'
            })
        }

        const crossSellingTeasers = ref([]);
        let params = {};

        if(!props.isUsedInActivity) {
            const quantity = Object.keys(ticketConfigurations.value.priceGroups).reduce((acc, key) => {
                return acc + ticketConfigurations.value.priceGroups[key].counter;
            }, 0);

            params = {
                quantity: quantity,
                startDate: selectedDateStart.value,
                endDate: selectedDateEnd.value || selectedDateStart.value,
                productId: selectedOption.value,
            };
        } else {
            console.log("ticketConfigurations.value.configurations", activityTicketConfigurations.value.configurations)
            const quantity = Object.keys(activityTicketConfigurations.value.configurations).reduce((acc, key) => {
                return acc + activityTicketConfigurations.value.configurations[key].amount;
            }, 0);

            params = {
                quantity: quantity,
                startDate: activitySelectedDateStart.value || activitySelectedDateEnd.value,
                endDate: activitySelectedDateEnd.value || activitySelectedDateStart.value,
                productId: props.activityId
            };
        }

        const fetchCrossSellingData = async () => {
            let url = getCrossSellingDataUrl();
            url = addParamsToUrl(url, new URLSearchParams(params));
            await fetcher(url).then((result) => {
                console.log("result", result)
                if(!window.location.href.includes('usedummycrossselling=1')) {
                    crossSellingTeasers.value = result;
                }
            })
        }

        onMounted(() => {
            fetchCrossSellingData();
        });

        // todo: remove dummy data
        const crossSellingDummyData = [
            {
                title: "Mountain Cart 1",
                image: "https://matterhorn-2022-feature-development.elements.zone/test-assets/542/image-thumb__542__ticket-teaser/Active%20-%20Mountain%20carts%203@2x.jpg",
                url: "#",
                price: 123,
                category: "Testtoptitle"
            },
            {
                title: "Testprodukt 2",
                image: "https://matterhorn-2022-feature-development.elements.zone/test-assets/542/image-thumb__542__ticket-teaser/Active%20-%20Mountain%20carts%203@2x.jpg",
                url: "#",
                price: 456,
                category: "Irgendwas anderes"
            },
            {
                title: "Warenkorb",
                image: "https://matterhorn-2022-feature-development.elements.zone/test-assets/542/image-thumb__542__ticket-teaser/Active%20-%20Mountain%20carts%203@2x.jpg",
                url: "#",
                price: 789,
                category: "Oha!"
            },
            {
                title: "Kartfahren",
                image: "https://matterhorn-2022-feature-development.elements.zone/test-assets/542/image-thumb__542__ticket-teaser/Active%20-%20Mountain%20carts%203@2x.jpg",
                url: "#",
                price: 1000,
                category: "Richtiger Schnapper"
            }
        ];

        if(window.location.href.includes('usedummycrossselling=1')) {
            crossSellingTeasers.value = crossSellingDummyData;
        }
        // todo end: remove dummy data


        return {
            step,
            continueUrl,
            cartUrl,
            checkoutUrl,
            translate,
            clickCheckoutButton,
            crossSellingTeasers,
            selectedCurrency,
            activitySelectedCurrency
        };
    }
});

if (typeof _trackingData !== 'undefined' && typeof _trackingData['click-checkout'] === 'undefined') {
    _trackingData['click-checkout'] = {
        'trigger': 'click',
        'datalayer': {
            'event': 'click_checkout',
            'type': 'ticket_configurator',
        }
    }
}
